import React from "react";
const MarriageProcedure = () => {
  return (
    <div className="birthCertProcedureContainer">
      <h2>
        Procedure for Marriage Certificate <span>Attestation</span> in Bangalore
      </h2>
      <p>
        The procedure for marriage certificate attestation in Bangalore involves
        several steps, each crucial for verifying the authenticity of the
        document. The main steps include:
      </p>
      <ol>
        <li>
          1. <span> Notary Attestation:</span> : The initial step involves
          getting the marriage certificate attested by a notary public. The
          notary verifies the authenticity of the document and adds their seal
          and signature.
        </li>
        <li>
          2. <span>Home Department Attestation:</span>The next step is
          attestation by the Home Department. This department verifies the
          document and ensures it is legitimate.
        </li>
        <li>
          3. <span>MEA (Ministry of External Affairs) Attestation:</span> The
          Ministry of External Affairs then attests the document, confirming its
          authenticity for international use.
        </li>
        <li>
          4. <span>Embassy Attestation:</span> After MEA attestation, the
          document is sent to the embassy of the destination country. The
          embassy verifies and attests the document, ensuring it meets their
          requirements.
        </li>
        <li>
          5. <span>MOFA (Ministry of Foreign Affairs) Attestation:</span> In
          some cases, the document may also need to be attested by the Ministry
          of Foreign Affairs in the destination country.
        </li>
      </ol>
      <p>
        Each step in this process involves adding seals and signatures to the
        documents, verifying their authenticity. Marriage certificate
        attestation in Bangalore thus involves a detailed verification process
        to ensure the document is genuine and can be trusted by foreign
        authorities.
      </p>
    </div>
  );
};

export default MarriageProcedure;
